import React, { Component } from 'react';
// @ts-ignore
import { Header, HeaderProps, Resources } from '../../components/header';
import Footer from '../../components/footer';
import SearchField from '../../components/search-field';
import { AtlasLink } from '../../components/atlas-link';
import './404.less';
import { translatableText } from '../../utils/translatable-text';

interface Props {
    entry: {
        resourceCards: Resources;
        title: string;
        message: string;
        header: HeaderProps;
        id: string;
        preview: boolean;
    };
}

export default class NotFound extends Component<Props> {
    render() {
        const {
            resourceCards,
            title,
            message,
            header,
            id,
            preview
        } = this.props.entry;

        return (
            <main
                className="not-found flex-column-page"
                data-testid="page-template"
            >
                <div className="content-wrapper">
                    <Header
                        resources={resourceCards}
                        logo={header.atlassianSupportLogo.url}
                        atlassianSupportLogo={header.atlassianSupportLogo}
                        atlassianLogo={header.atlassianLogo}
                        cloudProducts={header.cloudProducts}
                        serverProducts={header.serverProducts}
                        id={header.id}
                        showPreviewBanner={preview}
                        additionalLinks={header.additionalLinks}
                        pageId={id}
                    />
                    <div className="main-content-container margin-top-large">
                        <h1>{title}</h1>
                        <p>{message}</p>
                        <p>
                            {translatableText.visit.text + ' '}
                            <AtlasLink
                                href="/"
                                text="Atlassian Support"
                                dataName="atlassianSupportLink"
                            />
                            ,
                            {
                                translatableText.orTrySearchingOurDocumentation
                                    .text
                            }
                        </p>
                        <div className="not-found__search">
                            <SearchField />
                        </div>
                    </div>
                </div>
                <Footer
                    logo={header.atlassianLogo.url}
                    className={'margin-top-large'}
                />
            </main>
        );
    }
}
